import { useState } from "react";
import {
  AccordionCategoryDiv,
  TitleWrapper,
  TitleDiv,
  StyledChevronDown,
  StyledChevronUp,
} from "./styles";
import { AccordionProps } from "./types";

export const Accordion = (props: AccordionProps) => {
  const [isActive, setIsActive] = useState<boolean>(true);

  const icon = isActive ? (
    <StyledChevronUp
      onClick={() => {
        setIsActive(false);
      }}
    />
  ) : (
    <StyledChevronDown
      onClick={() => {
        setIsActive(true);
      }}
    />
  );

  const category = isActive ? (
    props.content?.map((cogDomain, index) => {
      return (
        <AccordionCategoryDiv
          selectedBool={props.isSelected === cogDomain}
          key={index}
          onClick={() => {
            props.setCogDomainFilter(cogDomain);
            props.setCategoryFilter(cogDomain);
            props.setIsSelected(cogDomain);
          }}
        >
          {cogDomain}
        </AccordionCategoryDiv>
      );
    })
  ) : (
    <></>
  );

  return (
    <div>
      <TitleWrapper
        selectedBool={props.isSelected === props.title}
        onClick={() => {
          props.setCategoryFilter(props.title.toLowerCase());
          props.setCogDomainFilter(undefined);
          props.setIsSelected(props.title);
        }}
      >
        <TitleDiv>{props.title}</TitleDiv>
        {props.content && icon}
      </TitleWrapper>
      <div>{category}</div>
    </div>
  );
};
